<Char>
    <div class="char { props.type || 'invalid' }">
        { props.letter || '' }
    </div>
</Char>